<template>
  <v-container fluid fill-height>
    <v-layout justify-center column>
      <v-form ref="entryForm" v-model="valid" @submit.prevent="onRegister">
        <v-container>
          <v-row>
            <v-col>
              <h2
                style=""
                class="
                  white--text
                  mb-6
                  mt-4
                  display-1
                  text-xs-center
                  font-weight-bold
                "
              >
              PowerCell registration
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                
                label="Förnamn*"
                :rules="[rules.required]"
                v-model="firstname"
                filled
                background-color="grey lighten-2"
                color="black"
              ></v-text-field>
              <v-text-field
                
                :rules="[rules.required]"
                v-model="lastname"
                label="Efternamn*"
                filled
                background-color="grey lighten-2"
                color="black"
              ></v-text-field>

              <v-text-field
                required
                label="Email*"
                v-model="email"
                :rules="[rules.required, rules.email]"
                :type="username"
                
                background-color="grey lighten-2"
                filled
                color="black"
              ></v-text-field>

              <v-text-field
                label="Lösenord*"
                filled
                v-model="password"
                
                background-color="grey lighten-2"
                color="black"
                :type="'password'"
              ></v-text-field>
              <v-text-field
                label="Lösenord*"
                filled
                v-model="passwordRepeated"
                
                background-color="grey lighten-2"
                color="black"
                :type="'password'"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
           
            

               <v-text-field
                
                v-model="company"
                 :rules="[rules.required]"
                label="Company*"
                filled
                background-color="grey lighten-2"
                color="black"
              ></v-text-field>

              <v-text-field
                
                v-model="position"
                label="Position"
                filled
                background-color="grey lighten-2"
                color="black"
              ></v-text-field>

               <v-select
          :items="industry"
          label="Industry"
          filled
           background-color="grey lighten-2"
                color="black"
        ></v-select>

             

              <v-checkbox
                color="orange"
                class=""
                v-model="checkboxGDRP"
                :rules="[
                  (v) =>
                    !!v ||
                    'Du måste godkänna Integritetspolicy för att fortsätta',
                ]"
                required
              >
                <div slot="label" style="color: white; font-size: 1.1em">
                  Jag har läst och accepterar

                  <a @click="openPolicy"> Integritetspolicy </a>
                </div>
              </v-checkbox>
            </v-col>
          </v-row>

          <v-row align="center" justify="center">
            <v-col cols="12" class="mt-0 pt-0" sm="5" md="5">
              <div></div>
              <v-btn filled large color="secondary" type="submit"
                >Registrera mig</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-layout>
    <v-dialog v-model="gdprDialog" width="500" class="">
      <div class="white text-md-left" style="padding: 50px 30px">
        <div class="summary-content">
          <h1></h1>
          <h1>Privacy Policy</h1>

          <p style="outline: none">
            Samtycke till behandling<br />
            Vilka personuppgifter samlar ni in när jag besöker www.ulrika.se?<br />
            Teknisk information<br />
            Vilka personuppgifter samlar ni på www.ulrika.se?<br />
            Hur använder ni mina personuppgifter?<br />
            Dina rättigheter<br />

            senaste ändrad 26 januari 2021
          </p>
        </div>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  components: {},
  data: () => ({
      industry: ['Aviation', 'Stationary', 'Marine', 'Off Road', 'Other'],
    username: "",
    gdprDialog: false,
    checkboxGDRP: false,
    valid: false,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 10 || "Name must be less than 10 characters",
    ],
    email: "",
    firstname: "",
    lastname: "",
    kommun: "",
    city: "",
    phone: "",
    password: "",
    company: "",
    contactPerson: "",
    radioGroup: null,
    customerToBdo: null,
    passwordRepeated: "",
    rules: {
      required: (value) => !!value || "Fältet krävs.",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Ingen gilltig email";
      },
    },
    items: ["Kinda", "Motala", "Söderköping"],
  }),
  methods: {
    openPolicy() {
      window.open(
        "https://powercell.se",
        "_blank"
      );
    },
    async onRegister() {
      if (this.$refs.entryForm.validate()) {
        if (this.password != this.passwordRepeated) {
          alert("Lösenorden matchar inte varandra.");
        }
        if (!this.checkboxGDRP) {
          alert("Du måste godkänna integritetspolicyn innan du kan fortsätta");
        } else {
          console.log("login", this.email, this.password);

          var register = await this.$auth
            .register(this.email, this.password)
            .catch(function (error) {
              // Handle Errors here.
              var errorCode = error.code;
              var errorMessage = error.message;
              // [START_EXCLUDE]
              if (errorCode == "auth/weak-password") {
                alert("Lösenordet är för svagt");
              } else {
                alert(errorMessage);
              }
            });
          if (register) {
            await this.$auth.addUserRecord({
              firstname: this.firstname,
              lastname: this.lastname,
              city: this.city,
              contactPerson: this.contactPerson,
              phone: this.phone,
              email: this.email,
              company: this.company,
              customerToBdo: this.customerToBdo,
            });

            this.$router.replace("menu");
          }
        }
      }
    },
  },
};
</script>